import { Routes } from '@angular/router';
import { MainLayout } from './layout/main-layout/main-layout';
import { authGuard } from './services/guards/auth-guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },

  {
    path: 'login',
    loadComponent: () => import('./layout/login/login').then((m) => m.Login),
  },

  {
    path: '',
    component: MainLayout,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./components/dashboard/dashboard').then((m) => m.DashboardComponent),
      },

      // CLAIM INTAKE
      {
        path: 'claim-intake',
        loadComponent: () =>
          import('./components/intake-forms/claim-intake/claim-intake').then((m) => m.ClaimIntake),
      },
      // // CALENDAR
      // {
      //   path: 'calendar',
      //   loadComponent: () => import('./components/calendar/calendar').then((m) => m.Calendar),
      // },

      // // MATTER INTAKE (SUPERADMIN only)
      // {
      //   path: 'matter-intake',
      //   canActivate: [authGuard],
      //   data: {
      //     roles: ['SUPERADMIN'],
      //   },
      //   loadComponent: () =>
      //     import('./components/intake-forms/matter-intake/matter-intake').then(
      //       (m) => m.MatterIntake,
      //     ),
      // },

      // SUBMISSIONS
      {
        path: 'submissions',
        loadComponent: () =>
          import('./components/submissions/submissions').then((m) => m.Submissions),
      },

      // EDGE MATTERS
      {
        path: 'edge-matters',
        loadComponent: () =>
          import('./components/kanban-board/edge-matter-board/edge-matters-board').then(
            (m) => m.EdgeMattersBoard,
          ),
      },
      // {
      //   path: 'edge-matters',
      //   loadComponent: async () => {
      //     const rawUser = sessionStorage.getItem('user');
      //     let normalizedRole = '';

      //     if (rawUser) {
      //       try {
      //         const parsedUser = JSON.parse(rawUser);
      //         normalizedRole = String(parsedUser?.role || '')
      //           .trim()
      //           .replace(/\s+/g, '')
      //           .toUpperCase();
      //       } catch {
      //         normalizedRole = '';
      //       }
      //     }

      //     if (normalizedRole === 'SUPERADMIN') {
      //       return import('./components/edge-matters/edge-matter-management/edge-matter-management').then(
      //         (m) => m.EdgeMatterManagement,
      //       );
      //     }

      //     return import('./components/edge-matters/edge-matter-board/edge-matters-board').then(
      //       (m) => m.EdgeMattersBoard,
      //     );
      //   },
      // },

      // ACTIVITY
      {
        path: 'activity',
        loadComponent: () => import('./components/activity/activity').then((m) => m.Activity),
      },
      // MATTER NOTES
      {
        path: 'matter-notes',
        loadComponent: () =>
          import('./components/matter-notes/matter-notes').then((m) => m.MatterNotes),
      },
      // EDGE FILES
      {
        path: 'edge-files',
        loadComponent: () => import('./components/edge-files/edge-files').then((m) => m.EdgeFiles),
      },
      // ADMIN
      {
        path: 'admin',
        canActivate: [authGuard],
        data: {
          roles: ['ADMIN (ALL)', 'SUPERADMIN'],
        },

        loadComponent: () => import('./components/admin/admin').then((m) => m.Admin),
        children: [
          {
            path: '',
            redirectTo: 'users',
            pathMatch: 'full',
          },
          {
            path: 'users',
            loadComponent: () =>
              import('./components/admin/user-management/user-management').then(
                (m) => m.UserManagement,
              ),
          },
          {
            path: 'organization-setup',
            canActivate: [authGuard],
            data: {
              roles: ['SUPER ADMIN'],
            },
            loadComponent: () =>
              import('./components/admin/organization-setup/organization-setup').then(
                (m) => m.OrganizationSetup,
              ),
          },
        ],
      },
    ],
  },
  // WILDCARD
  {
    path: '**',
    redirectTo: 'login',
  },
];
